import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../../Apis/request";
import { BaseURL, uniqueToken } from "../../../api/DataApis";

function Add() {
  document.title = "Category List | Add";
  let navigate = useNavigate();

  const [TitleName, setTitleName] = useState([]);
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [FilterCategoryList, setFilterCategoryListing] = useState([]);
  const [selectedFilterCategory, setSelectedFilterCategory] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [selectedSlug, setSelectedSlug] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [OCPPConnectorValue, setOCPPConnectorValue] = useState([]);
  const [ChargerType, setChargerType] = useState([]);
  const[SelectedOCPPConnectorValue, setselectedOCPPConnectorValue] = useState([]);

  const handleTitleName = (e) => {
    setTitleName(e.target.value);
  };

  const handleStatusType = (e) => {
    setSelectedStatusType(e.target.value);
  };
  const handleOCPPConnectorType = (e) => {
    setselectedOCPPConnectorValue(e.target.value);
  };
  const handleChargerType = (e) => {
    setChargerType(e.target.value);
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  }
  const handleFilterCategoryList = (e) => {
    const [id, slug] = e.target.value.split('|'); // Splitting the value into id and slug
    setSelectedId(id);
    setSelectedSlug(slug);
    
    // You can also trigger any other logic here based on the selected slug
  };

  

  const AddCategory = async () => {
    // Create a new FormData object
    let formData = new FormData();

    // Append the form data fields
    formData.append("key", "filter_category");
    formData.append("value", TitleName);
    formData.append("status", selectedStatusType);
    formData.append("status", selectedFilterCategory);
    formData.append("master_image", selectedFile);
    
    //master_image
    //change  filterlisting field according to backend
    // formData.append("status", selectedFilterCategory)
    // formData.append("status", selectedFilterCategory)
    // Make the API request
    let response = await request({
      url: `${BaseURL}/admin/master/`,
      method: "POST",
      data: formData, // Use the FormData object here
      headers: {
        'Content-Type': 'multipart/form-data', // Set Content-Type to multipart/form-data
        Authorization: `Bearer ${uniqueToken}`,
      }
    });

    // Handle the response
    if (response.statusCode === 200) {
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Filter Category Added Successfully...",
        showConfirmButton: false,
        timer: 1500,
      });
      navigate(`/masters/categorylist`);
    } else {
      // Handle errors
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add Filter Category",
      });
    }
  };


  const FetchfiltercategoryData = async () => {
    console.log("-------00------", uniqueToken);
    setLoading(true);

    const url = `${BaseURL}/admin/master?type=filter_category`
                                               
 
    try {
      const res = await request({
        url: url,
        method: "GET",
        data: JSON.stringify({
          // schoolyearID: schoolyearID,
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`, 
        },
      });

      console.log("res", res);

      if (res && res?.data) {
        setFilterCategoryListing(res?.data);
}

    
        
      
    
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchfiltercategoryData();
  }, []);
  const FetchOcppValue= async () => {
    console.log("-------00------", uniqueToken);
    setLoading(true);

    const url = `${BaseURL}/admin/master/occp-connector-0`
                                               
 
    try {
      const res = await request({
        url: url,
        method: "GET",
        data: JSON.stringify({
          // schoolyearID: schoolyearID,
        }),
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`, 
        },
      });

      console.log("res", res);

      if (res && res?.data) {
        setOCPPConnectorValue(res?.data);
}

    
        
      
    
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchOcppValue();
  }, []);
console.log("OCPPConnectorValue", OCPPConnectorValue);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                       Category Add
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr style={{ marginTop: "-10px" }} />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Title
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleTitleName}
                                className="form-control"
                                id="name_id"
                                name="name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="file"
                                onChange={handleFileChange}
                                className="form-control"
                                id="file"
                                name="file"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="statusType"
                              className="col-sm-2 control-label"
                            >
                              Filter Category 
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleFilterCategoryList}
                                type="text"
                                className="form-control"
                                id="statusType"
                                name="statusType"
                              >
                                <option value="0">Select filter category</option>
                                {FilterCategoryList.map((item) => {
                        return (
                          <option
                            key={item._id}
                            value={`${item._id}|${item.slug}`} 
                          >
                            {item.title}
                          </option>
                        );
                      })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        {selectedSlug.includes("connector") && (
                              <>
                                <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              OCPP Connector Value
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleOCPPConnectorType}
                                className="form-control"
                                id="name_id"
                                name="name"
                              >
                                <option value="0">select ocpp value</option>
                                {OCPPConnectorValue.map((item) => {
                        return (
                          <option
                            key={item._id}
                            value={`${item._id}|${item.slug}`} 
                          >
                            {item.title}
                          </option>
                        );
                      })}
                                </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                            
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="name_id"
                              className="col-sm-2 control-label"
                            >
                              Charger Type
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleChargerType}
                                className="form-control"
                                id="name_id"
                                name="name"
                              >
                                <option>select charger</option>
                                <option value="DC">AC</option>
                                <option value="AC">DC</option>
                                <option value="All">All</option>
                                </select>

                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                       
                              </>
                            )}
                        <div className="form-group">
                          <div className="row">
                            <label
                              htmlFor="statusType"
                              className="col-sm-2 control-label"
                            >
                              
                              Status 
                            </label>
                            <div className="col-sm-6">
                              <select
                                
                                onChange={handleStatusType}
                                className="form-control"
                                id="statusType"
                                name="statusType"
                              >
                                <option value="0">Select Status</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AddCategory}
                              value="Add Category"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
